<template>
  <!-- 银行转账支付页面 -->
  <div class="bank-payment-container">
    <div class="breadcrumb-wrapper">
      <BreadCrumb class="breadcrumb">
        <BreadCrumbItem>Home</BreadCrumbItem>
        <BreadCrumbItem>Cart</BreadCrumbItem>
        <BreadCrumbItem>Checkout</BreadCrumbItem>
        <BreadCrumbItem>Payment</BreadCrumbItem>
      </BreadCrumb>
    </div>
    <div
      v-if="!paidSuccess"
      class="bank-payment-content"
    >
      <!-- 订单成功|失败卡片 -->
      <StatusCard />
      <!-- 支付信息 -->
      <PaymentInfo :price="totalAmountUsd" />
      <!-- 图片上传模块 -->
      <UploadImage
        @paid-success="handlePaidSuccess"
        :data="orderInfo"
      />
    </div>
    <div
      v-else
      class="bank-payment-content paid-success"
    >
      <div class="paid-success-wrapper">
        <img
          src="@/assets/H5/order/paypal-success.svg"
          alt=""
        >
        <div class="text">
          <div class="text-1">
            Order has been paid successfully
          </div>
          <div class="text-2">
            Your order is on the way, please be patient.
          </div>
        </div>
        <div
          @click="$router.push('/orders')"
          class="button"
        >
          View Order
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, watch, computed } from 'vue'
import { useRoute } from 'vue-router'
import { fetchData } from '@/utils/fetch'
import BreadCrumb from '@/components/BreadCrumb/BreadCrumb.vue'
import BreadCrumbItem from '@/components/BreadCrumb/BreadCrumbItem.vue'
import StatusCard from './components/StatusCard.vue'
import PaymentInfo from './components/PaymentInfo.vue'
import UploadImage from './components/UploadImage.vue'
import { gaAnalytics, buriedPointUtil } from '@/utils/utils'
import router from '../../router'

const route = useRoute()

const orderInfo = ref(null)

const totalAmountUsd = ref(0)

const paidSuccess = ref(false)

const queryType = computed(() => route.query.type)

watch(paidSuccess, value => {
  if (value) {
    buriedPointUtil({ eventId: 'PPP503' })
  }
})

watch(queryType.value, () => {
  getOrderInfo()
})

const getOrderInfo = async () => {
  const orderNo = route.params.orderNo
  const { code, data } = await fetchData('/appb/b2b/order/page', {
    method: 'POST',
    body: JSON.stringify({
      orderNo
    })
  })
  orderInfo.value = data.rows[0]
  totalAmountUsd.value = orderInfo.value.b2bOrderVo.totalAmountUsd
}

const handlePaidSuccess = async () => {
  await getOrderInfo()
  router.push(`/bankPayment/${route.params.orderNo}?type=confirmed`)
}

onMounted(() => {
  document.documentElement.scrollTop = 0
  getOrderInfo()

  if (!queryType.value) {
    buriedPointUtil({ eventId: 'PRP501' })
  }

  if (queryType.value === 'confirmed') {
    buriedPointUtil({ eventId: 'PRP502' })
  }

  if (queryType.value === 'repay') {
    buriedPointUtil({ eventId: 'PRP503' })
  }

  if (queryType.value === 'paidSuccess') {
    paidSuccess.value = true
  } else {
    gaAnalytics('p_transfer_review_page_view', 'p_transfer_review_page_view')
  }
})
</script>

<style lang='less' scoped>
.bank-payment-container {
  min-height: calc(100vh - 220.5px - 128px);
  .breadcrumb-wrapper {
    display: flex;
    align-items: center;
    height: 48px;
    border-bottom: 1px solid var(--main-border-color);

    .breadcrumb {
      width: 1200px;
      margin: 0 auto;
    }
  }

  .bank-payment-content {
    width: 1200px;
    margin: 0 auto;

    &.paid-success {
      height: calc(100vh - 220.5px - 48px - 128px);
    }

    .paid-success-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 92px;
    }
    .text {
      text-align: center;
      line-height: 24px;
      color: #232323;
      .text-1 {
        font-size: 16px;
        font-family: mon-600;
      }
      .text-2 {
        font-size: 14px;
        font-family: mon-500;
      }
    }
    .button {
      margin-top: 16px;
      width: 162px;
      height: 40px;
      border-radius: 20px;
      border: 1px solid #b2b7c2;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #232323;
      font-family: mon-600;
      cursor: pointer;
    }
  }
}
</style>
